import { render, staticRenderFns } from "./MasterSupplierDashboard.vue?vue&type=template&id=0b7ff592&"
import script from "./MasterSupplierDashboard.vue?vue&type=script&lang=js&"
export * from "./MasterSupplierDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports